import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2325af7e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex navbar-gradient px-4 py-2"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "m-0 leading-0 text-[0px] flex items-center"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://brandincolor.com/wp-content/themes/incolor/assets/img/logo/new_logo_tm.png",
  alt: ""
})])], -1));
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _renderSlot(_ctx.$slots, "default", {}, undefined, true)]);
}